<div class="buy_sell_modal">
  <!-- Loader (removed for static version) -->
  <span>
    <!-- Buy Section (visible when activateSell is false) -->
    <div *ngIf="!activateSell">
      <p>
        <mat-toolbar class="buy-toolBar">
          <span style="font-size: 15px; line-height: 21px">BUY </span>
          <span class="spacer"></span>
          <mat-slide-toggle
            class="bsToggle"
            [(ngModel)]="activateSell"
            (change)="onToggleChange()"
            style="font-size: 15px; line-height: 21px; font-weight: 500"
          >
            SELL
          </mat-slide-toggle>
        </mat-toolbar>
      </p>
      <form [formGroup]="buyorderForm">
        <mat-radio-group
          color="primary"
          class="radioGroup custom-radio-group"
          formControlName="market"
        >
          <mat-radio-button style="font-size: 16px; line-height: 24px" value="M"
            >Market</mat-radio-button
          >
          <mat-radio-button style="font-size: 16px; line-height: 24px" value="L"
            >Limit</mat-radio-button
          >
        </mat-radio-group>
        <div class="input-section">
          <mat-form-field
            appearance="outline"
            class="custom-form-field"
            style="width: 90%"
          >
          <input matInput formControlName="number_of_coins" (input)="quantityChange($event)" (keypress)="numberOnly($event)" [readonly]="this.buyorderForm.value.market === 'L'"/>
            <span matSuffix class="suffix">{{ data.symbol }}</span>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="custom-form-field"
            style="width: 90%"
          >
          <input matInput formControlName="amount" (input)="amountChange($event)" (keypress)="numberOnly($event)" [readonly]="this.buyorderForm.value.market === 'M'"/>
            <span matSuffix class="suffix">INR</span>
          </mat-form-field>

          <div class="container">
            <!-- Bucket Order Toggle -->
            <div class="toggle-container">
              <mat-slide-toggle
                labelPosition="before"
                class="label"
                (change)="toggleChanged($event)"
              >
                Bucket Order
              </mat-slide-toggle>

              <mat-form-field
                appearance="outline"
                class="custom-form-field"
                style="width: 90%; margin-top: -10px"
              >
                <input
                  matInput
                  formControlName="bucketOrder"
                  (input)="bucketChange($event)"
                  [value]="bucketOrder || 1"
                  [disabled]="!checked"
                />
              </mat-form-field>
            </div>

            <!-- Option Legs Dropdown -->
            <div class="option-container" *ngIf="showOptionLeg">
              <p class="label">Option Legs</p>
              <mat-form-field appearance="outline" class="custom-form-field">
                <mat-select
                  [(ngModel)]="selectedStatus"
                  formControlName="status"
                >
                  <mat-option
                    *ngFor="let stat of stats"
                    [value]="stat.viewValue"
                  >
                    {{ stat.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <div class="balance-view">
        <span
          style="
            font-size: 10px;
            font-weight: 400;
            line-height: 15px;
            padding-left: 15px;
            color: #a0a2b1;
          "
        >
          Available balance
        </span>
        <span
          style="
            font-size: 10px;
            font-weight: 400;
            line-height: 15px;
            padding-right: 15px;
            color: #000;
          "
        >
          {{ this.bal }} INR
        </span>
      </div>
      <!-- <p>Low balance</p> -->
      <div class="reset">
        <button mat-raised-button class="cancel" (click)="onNoClick()">
          CANCEL
        </button>
        <button mat-raised-button class="buy-button" (click)="placeTrade('buy')">
          BUY
        </button>
      </div>
    </div>

    <!-- Sell Section (visible when activateSell is true) -->
    <div *ngIf="activateSell">
      <p>
        <mat-toolbar class="sell-toolBar">
          <span style="font-size: 15px; line-height: 21px">SELL </span>
          <span class="spacer"></span>
          <mat-slide-toggle
            class="bsToggle"
            [(ngModel)]="activateSell"
            (change)="onToggleChange()"
            style="font-size: 15px; line-height: 21px; font-weight: 500"
          >
            BUY
          </mat-slide-toggle>
        </mat-toolbar>
      </p>
      <form [formGroup]="buyorderForm">
        <mat-radio-group
          color="primary"
          class="radioGroup custom-radio-group"
          formControlName="market"
        >
          <mat-radio-button style="font-size: 16px; line-height: 24px" value="M"
            >Market</mat-radio-button
          >
          <mat-radio-button style="font-size: 16px; line-height: 24px" value="L"
            >Limit</mat-radio-button
          >
        </mat-radio-group>
        <div class="input-section">
          <mat-form-field
            appearance="outline"
            class="custom-form-field"
            style="width: 90%"
          >
            <input
              matInput
              formControlName="number_of_coins"
              (keypress)="numberOnly($event)"
              (input)="quantityChange($event)" [readonly]="this.buyorderForm.value.market === 'L'"
            />
            <span matSuffix class="suffix">{{ data.symbol }}</span>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="custom-form-field"
            style="width: 90%"
          >
          <input matInput formControlName="amount" (input)="amountChange($event)" (keypress)="numberOnly($event)" [readonly]="this.buyorderForm.value.market === 'M'"/>
            <span matSuffix class="suffix">INR</span>
          </mat-form-field>

          <div class="container">
            <!-- Bucket Order Toggle -->
            <div class="toggle-container">
              <mat-slide-toggle
                labelPosition="before"
                class="label"
                (change)="toggleChanged($event)"
              >
                Bucket Order
              </mat-slide-toggle>

              <mat-form-field
                appearance="outline"
                class="custom-form-field small-input"
              >
                <input
                  matInput
                  formControlName="bucketOrder"
                  (input)="bucketChange($event)"
                  [value]="bucketOrder || 1"
                  [disabled]="!checked"
                />
              </mat-form-field>
            </div>

            <!-- Option Legs Dropdown -->
            <div class="option-container" *ngIf="showOptionLeg">
              <p class="label">Option Legs</p>
              <mat-form-field appearance="outline" class="custom-form-field">
                <mat-select
                  [(ngModel)]="selectedStatus"
                  formControlName="status"
                >
                  <mat-option
                    *ngFor="let stat of stats"
                    [value]="stat.viewValue"
                  >
                    {{ stat.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <div class="balance-view">
        <span
          style="
            font-size: 10px;
            font-weight: 400;
            line-height: 25px;
            padding-left: 15px;
            color: #a0a2b1;
          "
        >
          Available balance
        </span>
        <span
          style="
            font-size: 10px;
            font-weight: 400;
            line-height: 25px;
            padding-right: 15px;
            color: #000;
          "
        >
          {{ this.bal }} INR
        </span>
      </div>
      <!-- <p>Low balance</p> -->
      <div class="reset">
        <button mat-raised-button class="cancel" (click)="onNoClick()">
          CANCEL
        </button>
        <button
          mat-raised-button
          class="sell-button"
          mat-raised-button
          (click)="placeTrade('sell')"
          [disabled]="showlowBalance"
        >
          SELL
        </button>
      </div>
    </div>
  </span>
</div>
